import React from "react";
import { useLocalization } from "@i18n";
import { GeneralDashboardCard } from "./GeneralDashboardCard";
import { GeneralDashboardFieldStack } from "./GeneralDashboardFieldStack";
import { RISK_MAPPING_FIELDS } from "../utils/generalFieldConfigs";

interface GeneralRiskMappingCardProps {
  data: Record<string, unknown> | null;
}

export const GeneralRiskMappingCard: React.FC<GeneralRiskMappingCardProps> = ({ data }) => {
  const { translate } = useLocalization();

  const fields = RISK_MAPPING_FIELDS.map((field) => ({
    labelKey: field.labelKey,
    value: data ? data[field.name] : null,
  }));

  return (
    <GeneralDashboardCard
      title={translate("general.dashboard.riskMapping.title")}
      titleVariant="large"
      className="h-full"
    >
      <GeneralDashboardFieldStack fields={fields} spread />
    </GeneralDashboardCard>
  );
};
